import { Box } from "@mui/material"
import {
  FocusContext,
  setFocus,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { DGText } from "../../components/common/DGText"
import { GenericButton } from "../../components/common/GenericButton"
import useTranslate, { Namespaces } from "../../hooks/use-translate"
import { TranslationKey } from "../../types"
import { comb, s } from "../../utilities/common"
import { supportedLocale } from "../../utilities/constants"
import { theme, TI } from "../../utilities/theme"

export const LocaleSelectScreen = ({ open }: { open?: comb<boolean> }) => {
  const { focusKey, ref } = useFocusable({
    isFocusBoundary: true,
  })
  const t = useTranslate()
  const navigate = useNavigate()

  useEffect(() => setFocus("localeSelect0"), [])

  return (
    <Box
      sx={{
        height: "100vh",
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        pl: s("537px"),
        pr: s("537px"),
      }}
    >
      <DGText
        tx={TI.H05tv}
        sx={{ color: theme.palette.white.main, mb: s("20px") }}
      >
        Choose Language
      </DGText>
      <FocusContext.Provider value={focusKey}>
        <Box ref={ref}>
          {supportedLocale.map((locale, i) => (
            <GenericButton
              key={"button:" + locale}
              focusKey={"localeSelect" + i}
              onEnterPress={() => {
                // close modal, to provide instant feedback
                open?.set?.(false)
                window.localStorage.setItem("locale", locale)
                document.getElementById("root")!.innerHTML = ""
                document.getElementById("root")!.style.transform =
                  "translate3d(0, 0, 0)"
                setTimeout(() => {
                  navigate(`/`)
                  window.location.reload()
                }, 300)
              }}
              sx={{ mt: s("10px") }}
            >
              <DGText
                tx={TI.Subheadline07tv}
                sx={{
                  fontWeight: 600,
                }}
              >
                {t(
                  `subtitle_language_${locale}` as TranslationKey<Namespaces.Common>,
                  { lng: locale },
                )}
              </DGText>
            </GenericButton>
          ))}
        </Box>
      </FocusContext.Provider>
    </Box>
  )
}
